import type { IDashboardTemplate } from "../types";
import { EFamilyTypes } from "../components/DashboardTemplatesTypes";
import { AssetsService } from "../../../../services/AssetsService";

const dashboard: IDashboardTemplate = {
    id: 11,
    title: "dashboard.templates.benchmark.title",
    description: "dashboard.templates.benchmark.description",
    descriptionLong: "dashboard.templates.benchmark.description.long",
    keyMetrics: "dashboard.templates.benchmark.keymetric",
    previewImage: AssetsService.assetUrl("/images/dashboard/templates/Benchmark-preview.png"),
    thumbnailImage: AssetsService.assetUrl("/images/dashboard/templates/Benchmark-thumb.png"),
    familyType: EFamilyTypes.Website,
    autoFillUserDomain: true,
    minItems: 2,
    maxItems: 5,
    widgets: [
        {
            pos: {
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                sizeX: 2,
                row: 0,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "Total",
                duration: "25m",
                type: "Graph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 0,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "EngagementBounceRate",
                webSource: "Total",
                duration: "25m",
                type: "Graph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "",
            },
        },
        {
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 1,
                col: 0,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "EngagementOverview",
                webSource: "Total",
                duration: "3m",
                type: "EngagementTableDashboard",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Engagement Metrics",
                tooltip: "Engagement Metrics.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 1,
                maxSizeX: 2,
                row: 2,
                col: 0,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "Total",
                duration: "3m",
                type: "PieChart",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Daily",
                    includeSubDomains: "true",
                },
                width: "1",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "Total Visits - Total.tooltip",
                title: "Total Visits Share",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 2,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "EngagementDesktopVsMobileVisits",
                webSource: "Desktop",
                duration: "3m",
                type: "Table",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 1,
                maxSizeX: 2,
                row: 3,
                col: 0,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "Desktop",
                duration: "3m",
                type: "PieChart",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                },
                width: "1",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "Desktop Visits Share.tooltip",
                title: "Desktop Visits Share",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 1,
                maxSizeX: 2,
                row: 3,
                col: 2,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "MobileWeb",
                duration: "3m",
                type: "PieChart",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                },
                width: "1",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Mobile Web Visits Share",
                tooltip: "Total Visits.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 4,
                col: 0,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "WebDemographicsAge",
                webSource: "Total",
                duration: "3m",
                type: "BarChartDemographics",
                filters: {},
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 4,
                col: 2,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "WebDemographicsGender",
                webSource: "Total",
                duration: "3m",
                type: "BarChartDemographicsGender",
                filters: {},
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "",
            },
        },
        {
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 5,
                col: 0,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "TrafficSourcesOverview",
                webSource: "Desktop",
                duration: "3m",
                type: "BarChart",
                filters: {
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 6,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Direct",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 6,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Paid Search",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 7,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Organic Search",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 7,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Display Ads",
                metric: "BrandedKeywords",
                webSource: "Desktop",
                duration: "12m",
                type: "Table",
                filters: {
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Search Branded Traffic",
                tooltip: "Search Branded Traffic.tooltip",
            },
        },
        {
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 8,
                col: 0,
            },
            properties: {
                fixedCountry: 999,
                selectedChannel: "Direct",
                metric: "WebsitesGeography",
                webSource: "Desktop",
                duration: "3m",
                type: "Table",
                filters: {
                    orderBy: "TotalShare desc",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                tooltip: "",
            },
        },
    ],
};

export default dashboard;
